import { render, staticRenderFns } from "./checkreviews.vue?vue&type=template&id=4512b674&scoped=true"
import script from "./checkreviews.vue?vue&type=script&lang=js"
export * from "./checkreviews.vue?vue&type=script&lang=js"
import style0 from "./checkreviews.vue?vue&type=style&index=0&id=4512b674&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4512b674",
  null
  
)

export default component.exports